import { render, staticRenderFns } from "./RichText50Image.vue?vue&type=template&id=3cf2ec49&scoped=true&"
import script from "./RichText50Image.vue?vue&type=script&lang=js&"
export * from "./RichText50Image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf2ec49",
  null
  
)

export default component.exports